import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Clipboard: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <g clipPath="url(#b)">
        <path
          fill="#002677"
          d="M28.9447 8.0692C28.8689 8.0644 28.5528 8.0465 28.5528 8.0465C28.0254 6.0106 26.1921 4.5 23.9912 4.5C21.7903 4.5 19.957 6.0106 19.4296 8.0466C19.4296 8.0466 19.077 8.0667 19.0377 8.0693H11.1433C10.4094 8.0693 9.81445 8.6642 9.81445 9.3981V42.1713C9.81445 42.9052 10.4094 43.5001 11.1433 43.5001H36.8583C37.5922 43.5001 38.1871 42.9052 38.1871 42.1713V9.398C38.1871 8.6641 37.5922 8.0692 36.8583 8.0692H28.9447Z"
        />
        <path
          fill="white"
          d="M35.2006 41.1356H12.8026C12.4586 41.1356 12.1797 40.8567 12.1797 40.5127V11.0565C12.1797 10.7125 12.4586 10.4336 12.8026 10.4336H15.9267C15.7996 10.7988 15.7166 11.1847 15.7166 11.5931V12.7753H32.2673V11.5931C32.2673 11.1847 32.1843 10.7987 32.0572 10.4336H35.2007C35.5447 10.4336 35.8236 10.7125 35.8236 11.0565V40.5127C35.8235 40.8567 35.5446 41.1356 35.2006 41.1356Z"
        />
        <path
          fill="#FF612B"
          d="M31.1989 35.1421H16.6637C16.0145 35.1421 15.4883 34.6159 15.4883 33.9667C15.4883 33.3175 16.0145 32.7913 16.6637 32.7913H31.1989C32.0771 32.7913 32.6452 33.7194 32.2456 34.5015C32.0447 34.8946 31.6404 35.1421 31.1989 35.1421ZM31.1989 28.0897H16.6637C16.0145 28.0897 15.4883 27.5635 15.4883 26.9143C15.4883 26.2651 16.0145 25.7389 16.6637 25.7389H31.1989C32.0771 25.7389 32.6452 26.667 32.2456 27.4491C32.0447 27.8422 31.6404 28.0897 31.1989 28.0897ZM31.1989 21.0373H16.6637C16.0145 21.0373 15.4883 20.5111 15.4883 19.8619C15.4883 19.2127 16.0145 18.6865 16.6637 18.6865H31.1989C32.0771 18.6865 32.6452 19.6146 32.2456 20.3967C32.0447 20.7899 31.6404 21.0373 31.1989 21.0373Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 0h48v48H.5z" />
      </clipPath>
      <clipPath id="b">
        <path fill="#fff" d="M.5 0h53.61v48H.5z" />
      </clipPath>
    </defs>
  </Box>
)
export default Clipboard
